import {
  GradientColorStop,
  interpolateGradientColor,
} from '@app/helpers/interpolate-gradient-color';
import { Palette } from '@mui/material/styles';

/**
 * Missing-materials share thresholds for the GIP KPI color ramp.
 * Tighter than the generic progress gradient because missing media is critical.
 */
export const GIP_MISSING_MATERIALS_GRADIENT_RATES = {
  /** Missing share at or below this stays success (green). */
  successMax: 0.03,
  /** Missing share at or below this is warning; above is error. */
  warningMax: 0.06,
} as const;

/**
 * Builds stops for missing-materials coloring:
 * 0–3% success, 3–6% warning, >6% error.
 */
export function buildGipMissingMaterialsGradientStops(palette: Palette): GradientColorStop[] {
  const { successMax, warningMax } = GIP_MISSING_MATERIALS_GRADIENT_RATES;
  return [
    { rate: 0, color: palette.success.main },
    { rate: successMax, color: palette.success.main },
    { rate: warningMax, color: palette.warning.main },
    // Snap to error just past the warning ceiling so >6% reads as critical.
    { rate: warningMax + 0.001, color: palette.error.main },
    { rate: 1, color: palette.error.main },
  ];
}

/**
 * Resolves the GIP missing-materials KPI color from `missing / total` in [0, 1].
 */
export function resolveGipMissingMaterialsGradientColor(
  missingRatio: number,
  palette: Palette,
): string {
  return interpolateGradientColor(missingRatio, buildGipMissingMaterialsGradientStops(palette));
}
